import N8nUsersList from './UsersList.vue';

export default N8nUsersList;
